import { render } from "./ProjectPublicationHistoryListItemText.vue?vue&type=template&id=122419b2"
import script from "./ProjectPublicationHistoryListItemText.vue?vue&type=script&lang=js"
export * from "./ProjectPublicationHistoryListItemText.vue?vue&type=script&lang=js"

import "./ProjectPublicationHistoryListItemText.vue?vue&type=style&index=0&id=122419b2&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__